import { render, staticRenderFns } from "./project-process-pictogram-update.vue?vue&type=template&id=bc92b5b0"
import script from "./project-process-pictogram-update.vue?vue&type=script&lang=js"
export * from "./project-process-pictogram-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports